import { useEffect, useState } from "react";
import Modal from "@/components/Modal";
import { InlineError } from "@/components/InlineError";
import { Ban, Loader2 } from "lucide-react";

export default function VoidReasonDialog({ open, title, message, confirmLabel = "Annuler l'opération", loading = false, error, onConfirm, onClose, testId = "void-reason-dialog" }) {
  const [reason, setReason] = useState("");
  const [touched, setTouched] = useState(false);
  useEffect(() => { if (open) { setReason(""); setTouched(false); } }, [open]);
  const empty = !reason.trim();
  const submit = () => { setTouched(true); if (empty) return; onConfirm(reason.trim()); };
  return (
    <Modal open={open} onClose={onClose} title={title || "Annuler l'opération"} testId={testId} zClass="z-[60]"
      footer={<>
        <button className="btn-outline" onClick={onClose} disabled={loading} data-testid="void-cancel-btn">Retour</button>
        <button className="btn-danger" onClick={submit} disabled={loading} data-testid="void-confirm-btn">
          {loading && <Loader2 className="w-4 h-4 animate-spin" />}{confirmLabel}
        </button>
      </>}>
      <div className="space-y-4">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 rounded-xl flex items-center justify-center shrink-0 bg-[#FEE2E2] text-[#B91C1C]"><Ban className="w-5 h-5" /></div>
          <p className="text-sm text-[#475569] leading-relaxed pt-1.5">{message}</p>
        </div>
        <div>
          <label className="lbl">Motif de l'annulation <span className="text-[#B91C1C]">*</span></label>
          <textarea value={reason} onChange={(e) => setReason(e.target.value)} rows={3} className="inp" placeholder="Ex. erreur de saisie, doublon, client absent…" data-testid="void-reason-input" />
          {touched && empty && <p className="text-xs text-[#B91C1C] mt-1">Le motif est obligatoire.</p>}
        </div>
        <InlineError message={error} />
      </div>
    </Modal>
  );
}
